import './App.css';
import TodoCont from './todoCont';

function App() {
  return (
    <div className="App">
      <h1 align="center">ToDo App</h1>
      <TodoCont/>
    </div>
  );
}

export default App;
